import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Sidebar.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const SidebarFooter: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <div className={concatClassName(styles['footer'], className)}>
        {children}
    </div>
);

SidebarFooter.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

SidebarFooter.defaultProps = {
    className: undefined,
    children: undefined
};

export default SidebarFooter;
